module.exports = __webpack_public_path__ + "img/SKTC_map.51cea18b.svg";